import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f810a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex animate-pulse flex-col gap-3",
  "data-testid": "dashboard-skeleton-mobile-day"
}
const _hoisted_2 = { class: "flex gap-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-6 rounded bg-slate-200" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-4 rounded bg-slate-200" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[30px] w-[30px] rounded-full bg-slate-200" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 flex-col gap-1.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-1/2 rounded bg-slate-200" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-1/3 rounded bg-slate-200" })
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "grid animate-pulse grid-cols-7 gap-px bg-gray-200",
  "data-testid": "dashboard-skeleton-mobile-month"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-2.5 w-3 rounded bg-slate-200" }, null, -1))
const _hoisted_11 = {
  key: 2,
  class: "parent text-sm overflow-x-auto animate-pulse"
}
const _hoisted_12 = { class: "sticky-header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-4 w-16 bg-slate-200 rounded mx-auto" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-4 w-8 bg-slate-200 rounded mx-auto" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"period flex gap-2 items-center justify-center h-12 bg-gray-100 border-b border-white\" data-v-05f810a8><div class=\"h-4 w-48 bg-slate-200 rounded\" data-v-05f810a8></div></div><div class=\"bg-white border-1 sticky-column h-40 flex flex-col items-center justify-center gap-2\" data-v-05f810a8><div class=\"h-4 w-20 bg-slate-200 rounded\" data-v-05f810a8></div><div class=\"h-3 w-12 bg-slate-200 rounded\" data-v-05f810a8></div></div><div class=\"bg-white border-1 shift-hours-column h-40 flex flex-col items-center justify-center gap-2\" data-v-05f810a8><div class=\"h-4 w-16 bg-slate-200 rounded\" data-v-05f810a8></div><div class=\"h-3 w-10 bg-slate-200 rounded\" data-v-05f810a8></div></div><div class=\"bg-white border-1 position-column h-40 flex flex-col items-center justify-center gap-2\" data-v-05f810a8><div class=\"h-4 w-16 bg-slate-200 rounded\" data-v-05f810a8></div></div>", 4)
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-12 w-full bg-white border border-gray-200 rounded shadow-sm p-2 flex flex-col gap-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-1/2 bg-slate-200 rounded" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-3/4 bg-slate-200 rounded" })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-12 w-full bg-slate-100 border border-dashed border-gray-300 rounded opacity-50" }, null, -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSkeleton',
  props: {
    variant: { default: 'grid' }
  },
  setup(__props: any) {

/** `grid` = skeleton de hoje (desktop e legado). As variantes de celular só aparecem com `isMobileLayout`. */


return (_ctx: any,_cache: any) => {
  return (_ctx.variant === 'mobile-day')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n) => {
            return _createElementVNode("div", {
              key: `strip-${n}`,
              class: "flex h-14 flex-1 flex-col items-center justify-center gap-1 rounded bg-white",
              "data-testid": "dashboard-skeleton-mobile-strip-day"
            }, _hoisted_5)
          }), 64))
        ]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
          return _createElementVNode("div", {
            key: `card-${n}`,
            class: "flex h-[58px] items-center gap-2 rounded-lg border border-gray-200 bg-white px-2",
            "data-testid": "dashboard-skeleton-mobile-card"
          }, _hoisted_8)
        }), 64))
      ]))
    : (_ctx.variant === 'mobile-month')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(35, (n) => {
            return _createElementVNode("div", {
              key: `cell-${n}`,
              class: "flex h-[84px] flex-col gap-1 bg-white p-1",
              "data-testid": "dashboard-skeleton-mobile-cell"
            }, [
              _hoisted_10,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (p) => {
                return _createElementVNode("div", {
                  key: p,
                  class: "h-[14px] w-full rounded-sm bg-slate-100"
                })
              }), 64))
            ])
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n) => {
              return _createElementVNode("div", {
                key: `head-${n}`,
                class: "weekDay card"
              }, _hoisted_17)
            }), 64)),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n) => {
              return _createElementVNode("div", {
                key: `date-${n}`,
                class: "weekDay card"
              }, _hoisted_22)
            }), 64))
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "contents"
            }, [
              _hoisted_23,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (d) => {
                return _createElementVNode("div", {
                  key: d,
                  class: "day-cell flex flex-col gap-2 p-1 h-40 justify-start bg-gray-50 boundary-escala"
                }, _hoisted_29)
              }), 64))
            ])
          }), 64))
        ]))
}
}

})